<template>
  <div class="dropdown dashboard-bookings-calendar-item">
    <button
      class="dashboard-bookings-calendar-item__button dropdown-toggle"
      type="button"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <strong class="dashboard-bookings-calendar-item__title">
        {{ title }}
      </strong>

      <span class="dashboard-bookings-calendar-item__date">{{ time }}</span>
    </button>

    <div class="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
      <div class="dashboard-bookings-calendar-item__details">
        <div class="border-bottom" v-if="booking.bookable">
          <h4>{{ booking.bookable.title }}</h4>
        </div>

        <div v-if="booking?.bookable?.owner">
          <i class="las la-hashtag mr-2" />

          <span>
            <strong class="d-block"> Boekingsnummer </strong>
            #{{ booking.id }}
          </span>
        </div>

        <div v-if="booking?.bookable?.owner">
          <i class="las la-hotel mr-2" />

          <span>
            <strong class="d-block"> Champagnehuis/Accommodatie </strong>
            {{ booking.bookable.owner.name }}
          </span>
        </div>

        <div class="d-flex">
          <i class="lar la-calendar mr-2" />

          <div>
            <strong class="d-block dashboard-bookings-calendar-item__date-string">{{ date }}</strong>
            <span>{{ time }}</span>
          </div>
        </div>

        <div>
          <i class="la la-user mr-2" />

          <span>
            <strong class="d-block"> Gasten </strong>
            {{ guest }}
          </span>
        </div>

        <div>
          <i class="la la-users mr-2" />

          <div>
            <strong class="d-block"> Personen </strong>

            <ul
              v-for="(group, index) in booking.groups"
              :key="index"
              class="m-0 p-0"
            >
              <li>{{ group.group }}: {{ group.amount }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "DashboardBookingsCalendarItem",
  props: ["attributes"],
  computed: {
    booking() {
      return this.attributes.customData.booking;
    },
    guest() {
      return this.booking?.details?.main_guest_fullname;
    },
    title() {
      const bookableTitle = this.booking?.bookable?.title;

      let title = `${this.guest}, ${bookableTitle}`;

      if (!title) {
        return "Geen activiteit/kamer bekend";
      }

      title = title.length > 16 ? title.substring(0, 16).concat("...") : title;

      return title;
    },
    localizedDate() {
      let startDate = this.booking.start_date;

      return moment(startDate).locale("nl");
    },
    time() {
      return this.localizedDate.format("HH:mm");
    },
    date() {
      return this.localizedDate.format("dddd, DD MMMM YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-bookings-calendar-item {
  line-height: 1rem;

  ::v-deep {
    .dropdown-menu {
      width: 100vw;
      max-width: 300px;
    }
  }

  &__button {
    text-transform: capitalize;
    text-align: left;
    background: none;
    padding: 0;
    border: none;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  &__title {
    font-size: 10px;
    font-weight: 600;
    color: darkgray;
    display: inline-block;
    line-height: 0.9rem;
    white-space: nowrap;
  }

  &__date {
    display: inline-block;
    font-size: 10px;
    color: darkgray;
    right: 0;
    position: absolute;
    background: #fff;
    padding-left: 0.25rem;
  }

    &__date-string {
        &:first-letter {
            text-transform: uppercase;
        }
    }

  &__details {
    font-size: 12px;

    h4 {
      font-size: 14px;
      font-weight: 400;
    }

    ul {
      list-style-type: none;
    }

    > div {
      display: flex;

      &:not(:last-child) {
        margin-bottom: 1.25rem;
      }
    }
  }
}
</style>
